/**
 * Stop-Go lamp - one chamber for go signal white color
 * - used in Charleroi
 * - needs to be adjusted for different cities when needed
 */

import Color from '../color.es6'
import Ren from '../ren-shape.es6'
import Element from './element.es6'

export default class ChaSgGo extends Element {
  setDefaultShapes () {
    this.shapes.push(
      new Ren.Rect({
        name: 'sg',
        x: 0,
        y: 0,
        width: 30,
        height: 30,
        strokeWidth: 0.5,
        fill: Color.offlineGray,
        opacity: 0.8
      }),

      new Ren.Circle({
        name: 'goSignal',
        x: 15,
        y: 15,
        radius: 15,
        fill: Color.offlineGray
        // fill: Color.offlineGray
      }),

      // signalling floor
      new Ren.Line({
        points: [15, 30, 15, 50],
        strokeWidth: 2,
        opacity: 0.8
      }),

      new Ren.Line({
        points: [0, 50, 30, 50],
        strokeWidth: 2,
        opacity: 0.8
      })
    )
  }

  applyStatusOnShapes (newVariables, deviceTypes) {
    // on GO signal make circle white

    const status = newVariables || this.status
    super.applyStatusOnShapes(status)
    if (status.signalGoStraight === 1 || status.signalGoLeft === 1 || status.signalGoRight === 1) {
      this.modifyShape('goSignal', 'fill', 'white')
    } else {
      this.modifyShape('goSignal', 'fill', Color.offlineGray)
    }
  }
}
